module.exports = __webpack_public_path__ + "img/Structures-4-mobile.f0c9c120.png";